document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.button.back.close').forEach((button) => {
    button.addEventListener('click', (e) => {
      if (window.name !== '') {
        e.preventDefault();
        window.close();
      }
    });
  });

});
